import { Button, Modal, Typography } from "antd";
import React from "react";
import Flex from "./Flex";

type ConfirmationModalProps = {
  modalIsOpenState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  onProceed?: () => void;
  onCancel?: () => void;
  headerText?: string;
  bodyText?: string;
  proceedButtonText?: string;
  proceedButtonColor?: "danger" | "default";
  proceedButtonType?: "primary" | "default" | "dashed" | "link" | "text";
  cancelButtonText?: string;
  cancelButtonType?: "primary" | "default" | "dashed" | "link" | "text";
  cancelButtonColor?: "danger" | "default";
};

export default function ConfirmationModal({
  modalIsOpenState: [modalIsOpen, setModalIsOpen],
  onProceed,
  onCancel,
  headerText = "",
  bodyText,
  proceedButtonText = "Proceed",
  cancelButtonText = "Cancel",
  proceedButtonType = "primary",
  cancelButtonType = "default",
  proceedButtonColor = "default",
  cancelButtonColor = "default",
}: ConfirmationModalProps) {
  if (!modalIsOpen) return null;
  return (
    <Modal
      title={""}
      open={modalIsOpen}
      footer={null}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={464}
      onCancel={() => setModalIsOpen(false)}
    >
      <div style={{ padding: "6px" }}>
        {!!headerText && (
          <Typography style={{ marginBottom: "10px", fontSize: "24px" }}>
            {headerText}
          </Typography>
        )}
        <Typography.Paragraph
          style={{ marginBottom: "40px", fontStyle: "italic" }}
        >
          {bodyText}
        </Typography.Paragraph>
        <Flex align="center" justify="space-between">
          <Button
            style={{ height: "37px", width: "100px", borderRadius: "8px" }}
            type={cancelButtonType}
            danger={cancelButtonColor === "danger"}
            onClick={() => {
              onCancel?.();
              setModalIsOpen(false);
            }}
          >
            {cancelButtonText}
          </Button>
          <Button
            style={{ height: "37px", borderRadius: "8px" }}
            type={proceedButtonType}
            danger={proceedButtonColor === "danger"}
            onClick={() => {
              onProceed?.();
            }}
          >
            {proceedButtonText}
          </Button>
        </Flex>
      </div>
    </Modal>
  );
}
